(function () {
  'use strict';
  /* Dot state for the mobile card swipe gallery (.wdgt-swipe).
     Single capture-phase listener so it survives facet AJAX re-renders. */
  document.addEventListener(
    'scroll',
    function (e) {
      var s = e.target;
      if (!s || !s.classList || !s.classList.contains('wdgt-secondary-hvr')) return;
      var card = s.closest('.wdgt-swipe');
      if (!card) return;
      var dots = card.querySelectorAll('.wdgt-swipe-dots span');
      if (dots.length < 2) return;
      var onSecond = s.scrollLeft > s.clientWidth / 2;
      dots[0].classList.toggle('is-active', !onSecond);
      dots[1].classList.toggle('is-active', onSecond);
    },
    true
  );
})();
